import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import Checkbox from '../../CoreWrappers/Checkbox';
import TagLabel from '../TagLabel';
import {currentResource} from '../../../util/utils';

const ColorLabelTag = ({name, id, wrapperClass, colorName, onSubmit, tagsSelected, checkbox, entity, isDisabled}) => {
	const selectedContacts = useSelector((store) => store.contacts.selected);
	const tagsSelectedSet = new Set(tagsSelected);

	const renderLabel = () => {
		let labelTag = currentResource.tags?.find((tag) => tag.id?.toLowerCase() === name?.toLowerCase().replace(/ /g, ''));
		if (labelTag === undefined) labelTag = {id, name};

		const props = {
			variant: colorName,
			text: name
		};

		return <TagLabel {...props} />;
	};

	return (
		<>
			{checkbox ? (
				<Checkbox
					id={id}
					name="Checkbox"
					ellipse
					indeterminate={tagsSelectedSet.size > 0 && tagsSelectedSet.size < selectedContacts.length}
					checked={tagsSelectedSet && tagsSelectedSet.size === selectedContacts.length}
					onChange={(e) =>
						onSubmit({
							id,
							entity,
							indeterminate: tagsSelectedSet.size < selectedContacts.length,
							checked: tagsSelectedSet && !(tagsSelectedSet.size < selectedContacts.length) ? true : false
						})
					}
					className={
						tagsSelectedSet.size > 0 && tagsSelectedSet.size < selectedContacts.length
							? 'partial-checked checkbox'
							: 'checkbox'
					}
					disabled={isDisabled}
					label={renderLabel()}
				/>
			) : (
				renderLabel()
			)}
		</>
	);
};

ColorLabelTag.defaultProps = {
	noOfLines: 1
};

ColorLabelTag.propTypes = {
	id: PropTypes.number.isRequired,
	styleClass: PropTypes.string.isRequired,
	key: PropTypes.string.isRequired,
	wrapperClass: PropTypes.string,
	tagsSelected: PropTypes.object.isRequired
};

export default ColorLabelTag;
